module.exports = __webpack_public_path__ + "static/media/report.a003f6fc.svg";